import { Tooltip } from '@material-ui/core';
import ActionButton, { MENU_BUTTON_CATEGORY } from 'src/components/UI/ActionButton';
import { useSelector } from 'react-redux';
import { Store, useAppDispatch } from 'src/redux/Store';
import { ButtonProps } from '@material-ui/core/Button/Button';
import GetAppIcon from '@material-ui/icons/GetApp';
// import { t } from 'src/lib/language';
import { ENTITIES } from 'src/models/QuerybuilderModel';
import { normalizeForForm } from 'src/lib/QueryBuilderHelper';
import { openDialog } from 'src/redux/actions/dialogActions';
import { DIALOGS } from 'src/models/DialogModel';

const UserDownloadReceiptButton = (props: ButtonProps) => {
  const dispatch = useAppDispatch();
  const { disabled } = props;

  // const lang = useSelector((state: Store) => state.language.language);

  const selections = useSelector(
    (state: Store) => state.selected[ENTITIES.payments] || [],
  );

  const isDisabled = useSelector(
    (state: Store) => {
      const result = state.querybuilder.payments?.result?.list || [];
      const normalized = result.map(
        (payment) => normalizeForForm(payment, ENTITIES.payments),
      );
      const payments = normalized.reduce((acc: any, item: any) => (
        { ...acc, [item.id]: item }), {});
      if (!selections.length) { return true; }
      const hasUnpaid = selections.some(
        (id:number) => !payments[id] || payments[id].payment_status !== 'paid',
      );
      const hasNoReceipt = selections.some(
        (id:number) => !payments[id] || !payments[id].tax_receipt_issued,
      );
      return hasUnpaid || hasNoReceipt || disabled;
    },
  );

  const handleOpen = () => {
    dispatch(openDialog({ dialog: DIALOGS.userDownloadReceipt }));
  };

  return (
    <>
      <Tooltip
        title="Download tax receipt"
        placement="top-start">
        <span>
          <ActionButton
            variant="outlined"
            category={MENU_BUTTON_CATEGORY.download}
            onClick={handleOpen}
            disabled={isDisabled}>
            <GetAppIcon />
          </ActionButton>
        </span>
      </Tooltip>
    </>
  );
};

export default UserDownloadReceiptButton;
